document.addEventListener('DOMContentLoaded', function() {
  const content = document.querySelector('.article-template__content');
  const tocNav = document.getElementById('toc-nav');
  if (!content || !tocNav) return;

  const headings = content.querySelectorAll('h2, h3');
  if (headings.length === 0) {
    const tocContainer = document.querySelector('.article-template__toc-container');
    if (tocContainer) {
      tocContainer.style.display = 'none';
    }
    return;
  }

  const tocList = document.createElement('ul');
  let currentH2List = null;
  let h2Count = 0;
  let h3Count = 0;

  headings.forEach((heading, index) => {
    if (!heading.id) {
      heading.id = 'heading-' + index;
    }

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + heading.id;
    
    if (heading.tagName.toLowerCase() === 'h2') {
      h2Count++;
      h3Count = 0;
      a.textContent = h2Count + '. ' + heading.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
      
      currentH2List = document.createElement('ul');
      li.appendChild(currentH2List);
    } else if (heading.tagName.toLowerCase() === 'h3') {
      h3Count++;
      a.textContent = h2Count + '.' + h3Count + '. ' + heading.textContent;
      li.appendChild(a);
      
      if (currentH2List) {
        currentH2List.appendChild(li);
      } else {
        tocList.appendChild(li);
      }
    }
  });

  tocNav.appendChild(tocList);

  // Intersection Observer for active class
  const observerOptions = {
    root: null,
    rootMargin: '-120px 0px -40% 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        document.querySelectorAll('.article-template__toc nav a').forEach(link => {
          link.classList.remove('active');
        });
        const activeLink = document.querySelector('.article-template__toc nav a[href="#' + id + '"]');
        if (activeLink) {
          activeLink.classList.add('active');
        }
      }
    });
  }, observerOptions);

  headings.forEach(heading => {
    observer.observe(heading);
  });
  
  // Smooth scroll
  document.querySelectorAll('.article-template__toc nav a').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - (window.innerHeight / 2.5);

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});
